<template>
  <v-container fluid>
    <v-container>
      <h1 class="container-title text-center">{{ location.name }}</h1>
    </v-container>
    <v-container>
      <div class="text-center">
        <h1 class="d-inline-block mr-2">{{ $t("locationsBalance") }}:</h1>
        <h1 v-html="convertPrice(location)" class="d-inline-block"></h1>
      </div>
    </v-container>
    <v-container>
      <v-row no-gutters justify="center">
        <v-col
          v-for="item in items"
          :key="item.id"
          cols="12"
          sm="6"
          md="4"
          class="my-2 mx-2"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :to="`/locations/${location.id}/${item.path}`"
              class="transition-card"
              :class="{ 'elevation-12': hover }"
              min-height="150"
            >
              <v-row no-gutters align="center">
                <v-col cols="9">
                  <v-card-title>
                    {{ item.title }}
                  </v-card-title>
                  <v-card-text style="min-height: 0px">
                    {{ item.description }}
                  </v-card-text>
                </v-col>
                <v-col cols="3" style="margin-top: 10px; padding-right: 10px">
                  <v-img :src="item.icon" />
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";
import iconInformation from "@/assets/icons/icon-information.svg";
import iconGallery from "@/assets/icons/icon-gallery.svg";
import iconPayments from "@/assets/icons/icon-payments.svg";
import iconGames from "@/assets/icons/icon-games.svg";
import iconTransactions from "@/assets/icons/icon-transactions.svg";
import iconSessions from "@/assets/icons/icon-sessions.svg";
import iconOrders from "@/assets/icons/icon-orders.svg";
import iconSchedule from "@/assets/icons/icon-schedule.svg";

export default {
  name: "LocationManagement",

  computed: {
    ...mapGetters(["location"]),
  },

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  data() {
    return {
      items: [
        {
          id: 1,
          title: this.$i18n.t("navBasicInformation"),
          active: true,
          description: this.$i18n.t("navDescription.information"),
          path: "location_info",
          icon: iconInformation,
        },
        {
          id: 2,
          title: this.$i18n.t("navGallery"),
          active: false,
          description: this.$i18n.t("navDescription.gallery"),
          path: "location_gallery",
          icon: iconGallery,
        },
        {
          id: 3,
          title: this.$i18n.t("navGames"),
          active: false,
          description: this.$i18n.t("navDescription.games"),
          path: "games_table",
          icon: iconGames,
        },
        {
          id: 4,
          title: this.$i18n.t("navPayments"),
          active: false,
          description: this.$i18n.t("navDescription.payments"),
          path: "payments",
          icon: iconPayments,
        },
        {
          id: 5,
          title: this.$i18n.t("transactionsTitle"),
          active: false,
          description: this.$i18n.t("navDescription.transactions"),
          path: "transactions",
          icon: iconTransactions,
        },
        {
          id: 6,
          title: this.$i18n.t("navSessions"),
          active: false,
          description: this.$i18n.t("navDescription.sessions"),
          path: "sessions",
          icon: iconSessions,
        },
        {
          id: 7,
          title: this.$i18n.t("navOrders"),
          active: false,
          description: this.$i18n.t("navDescription.orders"),
          path: "orders",
          icon: iconOrders,
        },
        {
          id: 8,
          title: this.$i18n.t("navSchedule"),
          active: false,
          description: this.$i18n.t("navDescription.schedules"),
          path: "schedules_and_playgrounds",
          icon: iconSchedule,
        },
      ],
    };
  },

  methods: {
    convertPrice(location) {
      if (location.balance) {
        let currency = location.b2b_currency;
        let price = new Intl.NumberFormat(
            navigator.language.split("-")[0]
        ).format(location.balance);

        if (currency === null) {
          return this.$i18n.t("CurrencyTitle");
        } else {
          if (currency.is_before) {
            return (
                currency.code +
                currency.blank_place +
                price +
                "</strong>"
            );
          } else {
            return (
                price +
                currency.blank_place +
                currency.code
            );
          }
        }
      }
    },
  }
};
</script>

<style>
.transition-card {
  transition: box-shadow 0.3s ease-in-out;
}
</style>
